import HasLabel from './HasLabel';
import { Team } from './Team';

export interface User {
    userName: string;
    initials: string;
    infinitrakApiKey: string;
    firstName: string;
    lastName: string;
    npiNumber: string;
    isRemote: boolean;
    teams: Team[];
    licenses: UserComplianceLicense[];
    /**
     * False for a user who has been taken off the active roster: they are hidden from assignment
     * dropdowns and listed under the Users page's Inactive view. Not an access control -- signing
     * in reactivates them.
     */
    active: boolean;
    /**
     * When the user was last deactivated, as the UTC string the API serializes. Cleared on
     * reactivation; the trail lives in history.
     */
    deactivatedDate?: string;
    /** Who last deactivated the user. Cleared on reactivation. */
    deactivatedBy?: string;
}

export class User extends HasLabel {
    constructor(obj?: User) {
        super();
        this.userName = "";
        this.active = true;
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toString(): string {
        if (this.lastName && this.firstName)
            return `${this.firstName} ${this.lastName}`;
        return this.userName;
    }
}

export interface UserComplianceLicense {
    active: boolean;
    state: string;
    licenseNumber: string;
    startDate?: Date;
    endDate?: Date;
}